const animation = {
  v: "5.7.4",
  fr: 25,
  ip: 0,
  op: 66,
  w: 800,
  h: 800,
  nm: "Comp 1",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "dot3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 5,
              s: [551, 397.941, 0],
              to: [0, -22.5, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 12,
              s: [551, 262.941, 0],
              to: [0, 0, 0],
              ti: [0, -6.667, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 18,
              s: [551, 397.941, 0],
              to: [0, 6.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 23.334,
              s: [551, 302.941, 0],
              to: [0, 0, 0],
              ti: [0, -4.833, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 28.667,
              s: [551, 397.941, 0],
              to: [0, 4.833, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 34,
              s: [551, 331.941, 0],
              to: [0, 0, 0],
              ti: [0, -2.5, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 39.334,
              s: [551, 397.941, 0],
              to: [0, 2.5, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 44.667,
              s: [551, 346.941, 0],
              to: [0, 0, 0],
              ti: [0, -4.667, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 50.889,
              s: [551, 397.941, 0],
              to: [0, 4.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0 },
              t: 58,
              s: [551, 374.941, 0],
              to: [0, 0, 0],
              ti: [0, -3.833, 0],
            },
            { t: 65.111328125, s: [551, 397.941, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [1335.652, 770.152, 0], ix: 1, l: 2 },
        s: { a: 0, k: [130, 130, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [74.305, 74.305], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.394316789216, 0.394316789216, 0.394316789216, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [1327.957, 768.566], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 66,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "dot2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 2,
              s: [408, 397.941, 0],
              to: [0, -22.5, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 9.444,
              s: [408, 262.941, 0],
              to: [0, 0, 0],
              ti: [0, -6.667, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 14.889,
              s: [408, 397.941, 0],
              to: [0, 6.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20.223,
              s: [408, 302.941, 0],
              to: [0, 0, 0],
              ti: [0, -4.833, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 25.556,
              s: [408, 397.941, 0],
              to: [0, 4.833, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 30.889,
              s: [408, 331.941, 0],
              to: [0, 0, 0],
              ti: [0, -2.5, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 36.223,
              s: [408, 397.941, 0],
              to: [0, 2.5, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 41.556,
              s: [408, 346.941, 0],
              to: [0, 0, 0],
              ti: [0, -4.667, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 47.777,
              s: [408, 397.941, 0],
              to: [0, 4.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0 },
              t: 54.889,
              s: [408, 374.941, 0],
              to: [0, 0, 0],
              ti: [0, -3.833, 0],
            },
            { t: 62, s: [408, 397.941, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [1335.652, 770.152, 0], ix: 1, l: 2 },
        s: { a: 0, k: [130, 130, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [74.305, 74.305], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.251531862745, 0.250560880175, 0.250560880175, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [1327.957, 768.566], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 66,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "dot1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [267, 397.941, 0],
              to: [0, -22.5, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 5.444,
              s: [267, 262.941, 0],
              to: [0, 0, 0],
              ti: [0, -6.667, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 11.889,
              s: [267, 397.941, 0],
              to: [0, 6.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 18.223,
              s: [267, 302.941, 0],
              to: [0, 0, 0],
              ti: [0, -4.833, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 23.556,
              s: [267, 397.941, 0],
              to: [0, 4.833, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 28.889,
              s: [267, 331.941, 0],
              to: [0, 0, 0],
              ti: [0, -2.5, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 34.223,
              s: [267, 397.941, 0],
              to: [0, 2.5, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 39.556,
              s: [267, 346.941, 0],
              to: [0, 0, 0],
              ti: [0, -4.667, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 45.777,
              s: [267, 397.941, 0],
              to: [0, 4.667, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0 },
              t: 52.889,
              s: [267, 374.941, 0],
              to: [0, 0, 0],
              ti: [0, -3.833, 0],
            },
            { t: 60, s: [267, 397.941, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [1335.652, 770.152, 0], ix: 1, l: 2 },
        s: { a: 0, k: [130, 130, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [74.305, 74.305], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.199264705882, 0.197399648031, 0.197399648031, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [1327.957, 768.566], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 66,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};

module.exports = animation;
